import convert from "convert-units";
import SearchableReactDropdown from "./SearchableReactDropdown";

export type UnitMeasure =
  | "length"
  | "area"
  | "mass"
  | "volume"
  | "each"
  | "temperature"
  | "time"
  | "digital"
  | "partsPer"
  | "speed"
  | "pace"
  | "pressure"
  | "current"
  | "voltage"
  | "power"
  | "reactivePower"
  | "apparentPower"
  | "energy"
  | "reactiveEnergy"
  | "volumeFlowRate"
  | "illuminance"
  | "frequency"
  | "angle";

interface UnitDropdownProps {
  measure: UnitMeasure;
  value?: string;
  onChange: (unit: string) => void;
  placeholder?: string;
  controlClassName?: string;
  menuClassName?: string;
  arrowClassName?: string;
}

const UnitDropdown = ({
  measure,
  value,
  onChange,
  placeholder = "Select a unit",
  controlClassName,
  menuClassName,
  arrowClassName,
}: UnitDropdownProps) => {
  const units = convert()
    .list(measure)
    .map((unit) => ({
      abbreviation: unit.abbr,
      label: `${unit.singular} (${unit.abbr})`,
    }));

  return (
    <SearchableReactDropdown
      options={units}
      getOptionLabel={(unit) => unit.label}
      getOptionValue={(unit) => unit.abbreviation}
      value={value}
      onChange={(unit) => onChange(unit.abbreviation)}
      placeholder={placeholder}
      controlClassName={controlClassName}
      menuClassName={menuClassName}
      arrowClassName={arrowClassName}
    />
  );
};

export default UnitDropdown;
